// removed by extract-text-webpack-plugin
module.exports = {"main":"_2latd5v7","icons":"_3h3meeRj","opacity-change":"_3r1FTF3w","one":"yBQrN2RR","two":"tE4Wzr9P"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/Loading/Loading.styl
// module id = 223
// module chunks = 0